import React from 'react';
import { observer } from 'mobx-react-lite';
import { convertAmount, gameConfigStore, useTranslation } from '@pascal/pascal-core';

import { gameStore } from '../../store';
import { globalTranslationKeys } from '../../enums';

export const MaxWinPopUp = observer(() => {
  const { limits } = gameConfigStore;
  const t = useTranslation();
  const { showMaxWinPopUpData } = gameStore;

  const isShowMaxWinPopUp = Object.values(showMaxWinPopUpData).filter((item) => item);

  return isShowMaxWinPopUp.length ? (
    <div className='max-win-popups'>
      <p className='max-win-pop-text'>{t(globalTranslationKeys.MaxWinPopUpText)}</p>
      <p className='max-win-pop-amount'>{`$ ${convertAmount(limits?.maxWin || '')}`}</p>
    </div>
  ) : (
    <></>
  );
});
